export const OUTAGE_ALERT: string = "";
//export const OUTAGE_ALERT: string = "<p><strong>Probleme beim Datendienstleister: </strong>Aktuell gibt es Probleme bei unserem Datendienstleister, die zu fehlenden-Charts und Fehlern beim Datenimport aus dem alten finantreff führen können. Wir arbeiten an einer Lösung.</p>";
